import React, { useState, useEffect, Fragment, useRef } from 'react';
import { Grid, Paper, Typography, Checkbox, CircularProgress, TableContainer, Table, TableHead, TableBody, TableRow, } from "@material-ui/core";
import { useDispatch } from 'react-redux';
import { StyledTableCell, StyledTableCellHead, StyledTableRow } from '../../atoms/table/tableStyles';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { invokeGetService, invokePostService, handleSnackBar } from '../../../store/global/actions'


export default function ClusterletsConfiguration({ onClose, id, onCompletion, typeOfClusterlet }) {
    console.log("ClusterletsConfiguration-----------------")
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [clusterlets, setClusterlets] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    useEffect(() => {
        setIsFetching(true)
        dispatch(invokeGetService('getClusterlets', {})).then(res => {
            if (res?.status == true) {
                
                //const nodes = res?.data?.filter(item => item.type === 2 || item.type === 3);
                let nodes = res?.data?.filter(item => typeOfClusterlet.includes(item.type));
                nodes = nodes.map( node => ({...node, includeInViewMetaJson: node.includeInViewMetaJson ? node.includeInViewMetaJson: false}))
                const nodesWithSortOrder = nodes.filter(node => node.sortOrder)
                const sortedNodes = nodesWithSortOrder.sort((a,b) => a.sortOrder - b.sortOrder);
                const tableDisplayOrder = [...sortedNodes, ...nodes.filter(node => !node.sortOrder)]
                setClusterlets([...tableDisplayOrder])
            }
            setIsFetching(false);
         })
        
    }, [])

    const onClusterletSelect = (clusterlet, checked) => {

        let updatedCluterlet = clusterlets.map(ele => {
            if (ele._id === clusterlet._id) {
                checked ? ele.includeInViewMetaJson = true : delete clusterlet.includeInViewMetaJson;
            }
            return ele;
        });
        setClusterlets(updatedCluterlet)
    }

    const onUpdate = () => {
        setIsUpdating(true);
        let modifiedClusterlets = [];
        clusterlets.forEach((ele,index) => {
            ele.sortOrder = index + 1
            modifiedClusterlets.push(ele);
        });
        dispatch(invokePostService('updateClusterlets', {clusterlets: modifiedClusterlets}, [])).then(res => { 
			setIsUpdating(false);
            if (res.status === true) {
                dispatch(handleSnackBar({ open: true, message: 'Configuration updated', severity: "success" }));
            }else{
                dispatch(handleSnackBar({ open: true, message: 'Could not update configuration', severity: "error" }));
            }
			
		});
    }

    const handleDragEnd = (results) => {

        if(!results.destination) return;

        let tempClusterlets = [...clusterlets]
        
        let [selectedRow] = tempClusterlets.splice(results.source.index, 1);
        tempClusterlets.splice(results.destination.index, 0, selectedRow);   
        setClusterlets(tempClusterlets)
    }

    return (
        <Grid container direction="row" spacing={2}>
                <Grid item xs={12} style={{ overflow: 'auto', width: '600px' }}>
                    <DragDropContext onDragEnd={(results) => handleDragEnd(results)}>
                    {<TableContainer component={Paper} >

                        <Table aria-label="customized table" >
                            <TableHead>
                                <TableRow>
                                    {/* <StyledTableCell align='center' style={{ width: 30 }}>#</StyledTableCell> */}
                                    <StyledTableCellHead align='center' style={{ width: 10 }}></StyledTableCellHead>
                                    <StyledTableCellHead align='left'>Name</StyledTableCellHead>
                                    <StyledTableCellHead align='left'>Description</StyledTableCellHead>
                                </TableRow>
                            </TableHead>

                            <Droppable droppableId='tbody'>
                            {(provided) => (
                            <TableBody ref={provided.innerRef} {...provided.droppableProps}>
                                {isFetching === true ?
                                    <StyledTableRow>
                                        <StyledTableCell align={'center'} colSpan={5} component="td" style={{ padding: 15 }}>
                                            Loading... <CircularProgress size={15} style={{ color: '#000' }} />
                                        </StyledTableCell>
                                    </StyledTableRow>
                                    : clusterlets.length < 1 ?
                                        <StyledTableRow>
                                            <StyledTableCell align={'center'} colSpan={5} component="td" style={{ padding: 15 }}>
                                                No clusterlets available.
                                            </StyledTableCell>
                                        </StyledTableRow>
                                        : clusterlets.map((clusterlet, index) => {

                                            return (
                                                <Draggable draggableId={clusterlet._id} index={index} key={clusterlet._id}>
                                                {(provided) => (
                                                <StyledTableRow key={index + 1} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                    {/* <StyledTableCell align={'center'} component="td" style={{ width: 30 }}>
                                                        {(index + 1)}
                                                    </StyledTableCell> */}

                                                    <StyledTableCell align={'center'} component="td" style={{ width: 10 }}>
                                                        <Checkbox color='primary' checked={clusterlet.includeInViewMetaJson === true  ? true : false} onChange={e => onClusterletSelect(clusterlet, e.target.checked)} />
                                                    </StyledTableCell>

                                                    <StyledTableCell align={'left'} component="td">
                                                        {clusterlet.name}
                                                    </StyledTableCell>
                                                    <StyledTableCell align={'left'} component="td">
                                                        {clusterlet.attributes.desc}
                                                    </StyledTableCell>

                                                </StyledTableRow>
                                                )}
                                                </Draggable>

                                            )
                                        })}
                                {provided.placeholder}
                            </TableBody>
                            )}
                            </Droppable>
                        </Table>

                    </TableContainer>}
                    </DragDropContext>
                </Grid>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                    <UpdateCancel updateDisable={isUpdating} content={isUpdating ? 'Updating..' : 'Update'} onUpdate={onUpdate} onCancel={onClose} />
                </Grid>
            </Grid>
    )
}